import React from 'react'
import Modal from '../../lib/Modal';
import styled from 'styled-components';
import { projects } from '../../constants/portfolio';
import mixpanel from 'mixpanel-browser';
import { devices } from '../../constants/devices.js';

const ProjectModal = ({
  showModal,
  setShowModal,
  scrollPos,
  projectToShow,
}) => {
    const showProjectDetails = () =>
      projects.filter((project) => project.id === projectToShow);
    let project = showProjectDetails();

    const onClickHandler = () => {
      console.log('data sent to mixpanel')
      mixpanel.track('Portfolio', { type: 'show project' });
    }
  return (
    <Modal
      show={showModal}
      handleClose={() => setShowModal(false)}
      scrollPos={scrollPos}
    >
      <ProjectDetails>
        <ImgWrapper width="50%">
          {project[0].images.slice(0, 2).map((image, index) => (
            <img
              key={`img-project-${index}`}
              className="img-1"
              src={image}
              alt="Profile"
            />
          ))}
        </ImgWrapper>
        <Details>
          <Title>{project[0].title}</Title>
          <TextCompany>{project[0].company}</TextCompany>
          <Text>{project[0].description}</Text>
          <Subtitle>Technologies:</Subtitle>
          <Text>{project[0].technologies}</Text>
          <LinkProject href={project[0].link}>Link</LinkProject>
          <button onClick={onClickHandler}>Mixpanel test</button>
        </Details>
        <ImgWrapper width="100%">
          {project[0].images.slice(2, 4).map((image, index) => (
            <img
              key={`img-project-${index}`}
              className="img-2"
              src={image}
              alt="Profile"
            />
          ))}
        </ImgWrapper>
        <ImgWrapper width="50%">
          {project[0].images.slice(4, 5).map((image, index) => (
            <img
              key={`img-project-${index}`}
              className="img-1"
              src={image}
              alt="Profile"
            />
          ))}
        </ImgWrapper>
        <ImgWrapper width="50%">
          {project[0].images.slice(5, 6).map((image, index) => (
            <img
              key={`img-project-${index}`}
              className="img-1"
              src={image}
              alt="Profile"
            />
          ))}
        </ImgWrapper>
      </ProjectDetails>
    </Modal>
  );
};

export default ProjectModal

const ProjectDetails = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-direction: column;
  @media ${devices.laptop} {
    flex-direction: row;
  }
  .img-1 {
    width: 70vw;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
      rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
    margin: 10px;
    @media ${devices.laptop} {
      width: 40vw;
    }
  }
  .img-2 {
    width: 100%;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
      rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
    margin: 10px 0px;
    @media ${devices.laptop} {
      margin: 10px;
    }
  }
`;

const ImgWrapper = styled.div`
  width: ${({ width }) => width};
  display: flex;
  flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

`;

const Details = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  @media ${devices.laptop} {
    margin-left: 90px;
    width: 40%;
  }
`;

const Title = styled.h2`
  position: relative;
  color: #262626;
  font-family: 'Frank Ruhl Libre', serif;
  font-size: 36px;
  font-weight: 900;
  text-align: left;
  margin: 0px;
  padding: 5px 0px;
  @media ${devices.tablet} {
    font-size: 48px;
  }
  @media ${devices.laptop} {
    font-size: 56px;
  }
`;

const TextCompany = styled.p`
  color: #262626;
  text-transform: uppercase;
  text-align: center;
  line-height: 2;
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 0.15rem;
`;

const Text = styled.p`
  color: #7f7f7f;
  text-align: left;
  line-height: 2;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 300;
`;

const LinkProject = styled.a`
  text-transform: uppercase;
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  font-weight: 300;
  letter-spacing: 0.1rem;
  text-decoration: none;
  width: 150px;
  box-sizing: border-box;
  margin-top: 30px; 
  padding: 5px 50px;
  border-radius: 3px;
  border: 1px solid #ee0b72;
  cursor: pointer;
`;

const Subtitle = styled.p`
  color: #262626;
  text-align: left;
  text-transform: uppercase;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  letter-spacing: 0.1rem;
  padding: 5px 0px;
`;